import HelloImage from './HelloImage';

export default HelloImage;